module.exports = __webpack_public_path__ + "static/img/coming-soon_cover.0e1b0e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sprite/series/coming-soon_cover.png
// module id = Iq8d
// module chunks = 0